import { Moment } from "moment-timezone";
import { useRef, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { BookingConfig } from "@ct-react/calendar";
import { booking } from "../../i18n/sharable-defs";
import { useMediaQueryDown, useMediaQueryUp } from "../../hooks/media-queries";
import { SkeletonableProps } from "../../tools/components";
import WrapBookingCalendar, { WrapBookingCalendarHandler } from "../common/wrap-booking-calendar";
import Button from "../common/button";
import "./rental-availabilities.scss";

const transDefs = defineMessages({
  title: { id: "article.rubrics.availability", defaultMessage: "Calendrier des disponibilités" }
});

const RentalAvailabilitiesPart = ({ className, data: config }: SkeletonableProps<BookingConfig<Moment>>) => {

  const intl = useIntl();

  const calendarRef = useRef<WrapBookingCalendarHandler>(null);
  const [ resettable, setResettable ] = useState<boolean>(false);

  const isCompact = useMediaQueryDown("desktop");
  const isBig = useMediaQueryUp("max-screen");
  const wrapperClasses = classNames("availabilities-part", className);

  return (
    <div className={wrapperClasses}>
      <h2>{intl.formatMessage(transDefs.title)}</h2>
      <div className="calendar">
        <WrapBookingCalendar ref={calendarRef}
                             config={config}
                             numberOfMonths={isCompact ? 1 : !isBig ? 2 : 3}
                             resettableChange={setResettable} />
        <Button type="button"
                className="reset link small no-border"
                disabled={!resettable}
                onClick={() => calendarRef.current?.reset()}>
          {intl.formatMessage(booking.reset)}
        </Button>
      </div>
    </div>);

}

export default RentalAvailabilitiesPart;
